import { render, staticRenderFns } from "./supportTicketDetail.vue?vue&type=template&id=07f5feb9&scoped=true&"
import script from "./supportTicketDetail.vue?vue&type=script&lang=js&"
export * from "./supportTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/ticketManagement/supportTicketDetail.css?vue&type=style&index=0&id=07f5feb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5feb9",
  null
  
)

export default component.exports